// extracted by mini-css-extract-plugin
module.exports = {"center":"__404_center__jADTU","sectionWrapper":"__404_sectionWrapper__QOOcO"};